export const Text = ({ children, ...props }) => <p {...props}>{children}</p>;

export const Break = () => <br />;

export const Image = ({ url, props }) => <img src={url} {...props} />;
